import styled from 'styled-components/native';

export const CardWrapper = styled.View<{ isFirst?: boolean }>`
  margin-top: ${({ theme, isFirst }) => (isFirst ? '0px' : theme.isMobile ? '8px' : '16px')};
`;
